
import React from 'react'
import Bannerspage from "./Bannerspage";
import Engineeringsubscriptionplans from "./Engineeringsubscriptionplans";
import Aboutsubscription from "./Aboutsubscription";
import "./Homes.css";
import { Link } from "react-router-dom";

function Engeeringsubscription() {
    return (
        <div>
            <div className=' home-banner-scrolling'
                style={{
                    // marginTop: "105px",
                    marginBottom: "50px",
                    overflow: "auto",
                    scrollbarWidth: "none",
                    width: "100vw",
                    marginLeft: 0,
                    padding: 0
                }}>
                <div style={{ width: "100%" }}>
                    <Bannerspage />
                </div>
                <div style={{ width: "100%" }}>
                    <Aboutsubscription />
                    <Engineeringsubscriptionplans />
                </div>
                <br></br>
            </div>
        </div>
    )
}

export default Engeeringsubscription
